import React from "react";

import { css } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";

import { useStyles } from "@/hooks/useStyles";
import { CenteredLoader } from "@/uiKit/atoms/pending/CenteredLoader.tsx";
import { DeviceSelectionList } from "@/uiKit/organisms/DeviceSelectionList";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";

export const DeviceSelectionPage: React.FC = () => {
  const styles = useStyles(makeStyles);
  return (
    <div className={styles.container}>
      <QueryAwait errorFallback={HandledErrorCard} pendingFallback={CenteredLoader}>
        <DeviceSelectionList />
      </QueryAwait>
    </div>
  );
};

const makeStyles = () => ({
  container: css``,
});
